<template>
  <div>
    <span>经度{{lon}}</span>
    <span>纬度{{lat}}</span>
    <span>精度{{accuracy}}</span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lon: "经度",
      lat: "纬度",
      accuracy:''
    };
  },
  created() {
           let options = {
        enableHighAccuracy: true,
        maximumAge: 10000
      };
    navigator.geolocation.watchPosition(
      this.success(),
      this.onError(),
      options
    );
  },
  methods: {
      success(){
          return position =>{
              this.lat = position.coords.latitude
            this.lon = position.coords.longitude
            this.accuracy = position.coords.accuracy 
              console.log(position.coords.latitude)
          }
      },
      onError(error){
          console.log(error)
      }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/test.vue